import { useEffect } from "react";
import { Link, useLocation } from "react-router-dom";
import { toAbsoluteUrl } from '../../helpers'
import { Topbar } from './Topbar'
import { Menu, X } from 'lucide-react'
import { DrawerComponent, MenuComponent } from '../../assets/ts/components'
import '../../assets/css/publicPages.css'


const menuItems = [
  {
    title: 'Home',
    slug: 'home',
  },
  {
    title: 'About',
    slug: 'about-us',
  },
  {
    title: 'Project Evaluation',
    slug: 'project-evaluation',
  },
  {
    title: 'Investor Prospectus',
    slug: 'investor-prospectus',
  },
  {
    title: 'Governance Tools & Methods',
    slug: 'governance-tools-and-methods',
  },
  {
    title: 'Gigamap',
    slug: 'critical-gigamaps',
  },
  {
    title: 'EVE',
    slug: 'artificial-intelligence',
  },
  {
    title: 'Contact Us',
    slug: 'contact-us',
  }
]


export function PublicHeaderWrapper() {
  const location = useLocation();

  // Auth pages (login/register) render this header outside PublicPageLayout,
  // so menu/drawer instances must be created here after mount / route change.
  useEffect(() => {
    const timeout = setTimeout(() => {
      MenuComponent.reinitialization();
      DrawerComponent.reinitialization();
      (window as any)?.KTMenu?.createInstances?.();
    }, 0);

    return () => clearTimeout(timeout);
  }, [location.pathname]);

  const NavigationMenu = ({ mobile = false }: { mobile?: boolean }) => {
    return (
      <>
        {menuItems.map((item) => {
          const path = `/pages${item.slug ? `/${item.slug}` : ""}`;

          const isActive = location.pathname === path;

          return (
            <div
              className={`${mobile ? "" : "menu-item me-lg-1"}`}
              key={item.slug}
            >
              <Link
                to={path}
                className={`menu-link ${isActive ? "menu-link-active" : "text-dark"} fw-bold`}
              >
                {item.title}
              </Link>
            </div>
          );
        })}
      </>
    );
  };


  return (
    <>
      <div
        className='public-header position-absolute w-100 top-0'
      >
        <div className={`d-flex align-items-center justify-content-between w-100 public-pages-container`}>
          <div className='d-flex align-items-center flex-wrap'>
            <div className='header-logo me-5 me-md-14'>
              <div className="d-flex align-items-center">
                <button
                  className="btn btn-icon btn-active-color-primary w-50px h-50px d-block d-xl-none me-2"
                  id="kt_app_sidebar_mobile_toggle"
                >
                  <Menu size={32} className='text-black' />
                </button>
                <Link to="/pages/home">
                  <img
                    alt='Logo'
                    src={toAbsoluteUrl('media/svg/logos/western-cape-government-logo-black.svg')}
                    className='h-60px d-none d-md-block'
                  />
                  <img
                    alt='Logo'
                    src={toAbsoluteUrl('media/svg/logos/wcg-small-logo.svg')}
                    className='h-40px d-block d-md-none'
                  />
                </Link>
              </div>
            </div>
            <div className='d-none d-xl-flex public-nav align-items-center ms-1 ps-1 fs-6'>
              <NavigationMenu />
            </div>
          </div>

          {/* begin::Wrapper */}
          <div className='d-flex align-items-center' style={{ gap: '1rem' }}>
            <div className='d-flex align-items-stretch flex-shrink-0 ms-2'>
              <Topbar />
            </div>
          </div>
          {/* end::Wrapper */}
        </div>
      </div>
      <div id="kt_app_sidebar" className="app-sidebar drawer-on flex-column align-items-center" aria-label="Toggle navigation menu" data-kt-drawer="true" data-kt-drawer-name="app-sidebar" data-kt-drawer-activate="{default: true, xl: false}" data-kt-drawer-overlay="true" data-kt-drawer-direction="top" data-kt-drawer-toggle="#kt_app_sidebar_mobile_toggle"  >
        <button
          type="button"
          className="btn btn-icon position-absolute top-0 end-0 m-5 z-3"
          id="kt_app_sidebar_mobile_toggle"
        >
          <X size={24} className="text-black" />
        </button>

        <div className="d-flex flex-column gap-10 align-items-center justify-content-center h-100 my-20">
          <NavigationMenu mobile />
        </div>
      </div>
    </>
  )
}
